if (!customElements.get("banner-collection-list-slider")) {
  class BannerCollectionListSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.initSlider();
      if (Shopify.designMode) {
        document.addEventListener(
          "shopify:section:load",
          this.handleSectionLoad.bind(this),
        );
      }
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
      if (Shopify.designMode) {
        document.removeEventListener(
          "shopify:section:load",
          this.handleSectionLoad.bind(this),
        );
      }
    }

    handleSectionLoad(event) {
      if (
        event.detail.sectionId !==
        this.closest(".shopify-section").id.replace("shopify-section-", "")
      )
        return;
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
      this.initSlider();
    }

    initSlider() {
      if (typeof Swiper === "undefined") {
        setTimeout(this.initSlider.bind(this), 50);
        return;
      }

      const swiperContainer = this.querySelector(".swiper");
      if (!swiperContainer) return;

      this.swiper = new Swiper(swiperContainer, {
        slidesPerView: 1.5,
        spaceBetween: 16,
        loop: false,
        centeredSlides: false,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        grabCursor: true,
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          750: {
            slidesPerView: 3.5,
            spaceBetween: 32,
            slidesOffsetBefore: 50,
            slidesOffsetAfter: 50,
          },
        },
      });
    }
  }

  customElements.define(
    "banner-collection-list-slider",
    BannerCollectionListSlider,
  );
}
